import React from 'react';

import '../../css/main.css';

import {Checkbox, FormControlLabel, FormGroup, Tooltip} from '@material-ui/core';


function CustomCheckbox({
    id, name, labelName, defaultValue, options,
    codes, comms, items,
    codeMode, selectAll, onChange, 
    paddingLeft, alignType, labelType,tooltip , marginRight, labelMinusMargin, compact}) {

        // if(id === "kCarc"){
        //     paddingLeft = "40px";
        // }
        if(id === "dupCnt"){
            // paddingLeft = "8px";
            // marginRight = "-11px";
        }


    const handleChange = (e) => { 
        const { name, checked } = e.target;
        let event = {
            target: {}
        };
        event.target["name"] = name;
        if (checked) {
            event.target["value"] = "Y";
        } else { event.target["value"] = "N"; }

        if (onChange) {
            onChange(event);
        }
    };


    return (
        <>
            <div className={"h_Label1" + (alignType ? alignType : '') + " checks" + (labelType ? " h_Label1" + (alignType ? alignType : '') + "_" + labelType : "")} style={{
                whiteSpace: "pre",
                paddingTop: compact ? "0px" : "9px",
                paddingLeft: paddingLeft,
                marginRight : marginRight,
                ...(compact ? { width: "auto", minWidth: 0, display: "flex", alignItems: "center" } : {})
            }}>

                {options ?
                    options.map((option, i) =>
                        <React.Fragment key={"checkbox" + option.name + option.defaultValue + i}>

                            <FormGroup row={!!compact} style={compact ? { alignItems: "center", marginTop: "2px", position: "relative", top: "3px" } : undefined}>
                                <div title = {tooltip!=""?tooltip:""} >
                                    <FormControlLabel control=
                                        {<Checkbox 
                                            id={option.name}
                                            checked={option.defaultValue === "N" ? false  : true}
                                            name={option.name}
                                            onChange={handleChange}
                                            size={compact ? "small" : "medium"} />}
                                        style={compact ? { marginLeft: 0, marginRight: "3px" } : undefined}
                                        
                                        label={
                                            labelMinusMargin ? (
                                            <span style={{ 
                                                width: '100%', 
                                                textAlign: 'right', 
                                                display: 'block', 
                                                marginRight: '-16px' 
                                            }}>
                                                {option.labelName}
                                            </span>
                                            ) : (
                                            option.labelName
                                            )
                                        }
                                        // label={
                                        //     <span
                                        //             // style={{ 
                                        //             //     width: '100%', 
                                        //             //     textAlign: 'right',
                                        //             //     display: 'block',
                                        //             //     marginRight: '-16px'
                                        //             //     }}
                                        //     >
                                        //     {option.labelName}
                                        //     </span>
                                        // }
                                    />
                                </div>
                            </FormGroup>

                        </React.Fragment>
                    )

                    : ""}

            </div>
        </>
    );
}

export default CustomCheckbox;
